import type { ProviderImportProfile } from '@timelyapp/integration-cloud-api-spec';
import { Box, Text } from '@timelyapp/react';
import React from 'react';
import type { GetSubscribableResourcesApiResponse } from '~redux/modules/tic/api-slice/GENERATED_ARTIFACT';
import { SubscriptionResourceCard } from './Integrations.Shared.SubscriptionResourceCard';

type SubscribableResource = GetSubscribableResourcesApiResponse['subscriptions'][0];

export const SubscriptionsList: React.FC<{
  subscriptions: SubscribableResource[];
  onToggle: (resource: SubscribableResource) => void;
  onManageSubscriptions?: (resource: SubscribableResource) => void;
  emptyStateMessage?: string;
  activeProfile?: ProviderImportProfile;
}> = React.memo(
  ({
    subscriptions,
    onToggle,
    onManageSubscriptions,
    emptyStateMessage = 'No subscriptions available',
    activeProfile,
  }) => {
    if (!subscriptions?.length) {
      return (
        <Box.Column
          gap="medium"
          alignItems="center"
          justifyContent="center"
          style={{ padding: '2rem' }}
        >
          <Text color="subtle" size="medium">
            {emptyStateMessage}
          </Text>
        </Box.Column>
      );
    }

    return (
      <Box.Column gap="medium">
        {subscriptions.map(subscription => (
          <SubscriptionResourceCard
            key={subscription.subscription_id}
            resource={subscription}
            onToggle={onToggle}
            onManageSubscriptions={onManageSubscriptions}
            activeProfile={activeProfile}
          />
        ))}
      </Box.Column>
    );
  }
);

SubscriptionsList.displayName = 'SubscriptionsList';
